import * as tslib_1 from "tslib";
import { useContext, useCallback } from 'react';
import { logger } from '../BiLogger.logger';
import { BiContext } from '../BiLogger.context';
import { SessionContext } from '../../Context';
export function useBiLogger() {
    var biContext = useContext(BiContext);
    var publicSession = useContext(SessionContext);
    var logEvent = useCallback(function (eventData) {
        var mergedData = tslib_1.__assign({}, biContext, eventData);
        var _rankIndex = mergedData._rankIndex, _rankOffset = mergedData._rankOffset, href = mergedData.href, biData = tslib_1.__rest(mergedData, ["_rankIndex", "_rankOffset", "href"]);
        if (typeof _rankOffset !== 'undefined' &&
            typeof _rankIndex !== 'undefined') {
            biData.rank = _rankOffset + _rankIndex;
        }
        return logger.log(publicSession, biData);
    }, [biContext, publicSession]);
    return logEvent;
}
//# sourceMappingURL=useBiLogger.js.map